import { getIsAutomaticReplyEnabled, getPeriodicReplyEnabled, } from '../selectors/getStoreProperties';
/**
 * Utility function to get auto reply status
 * @returns OofState type
 */
export default function getAutoReplyStatus() {
    var isAutomaticReplyEnabled = getIsAutomaticReplyEnabled();
    var periodicReplyEnabled = getPeriodicReplyEnabled();
    var autoReplyState;
    if (isAutomaticReplyEnabled) {
        autoReplyState = 1 /* Enabled */;
        if (periodicReplyEnabled === true) {
            autoReplyState = 2 /* Scheduled */;
        }
    }
    else {
        autoReplyState = 0 /* Disabled */;
    }
    return autoReplyState;
}
//# sourceMappingURL=getAutoReplyStatus.js.map